import React, { useState } from "react";
import styled from "styled-components";

import { exists } from "@examspark/common";
import {
  Button,
  Modal,
  ModalProps,
  SelectInput,
  Toolbar,
} from "@examspark/common-ui";
import { Classroom } from "@examspark/types";

import { useQueryGetUserClassrooms } from "../../api/operations/classroom";
import { useModal } from "../../hooks/useModal";
import { useAppContext } from "../../providers/AppContext";

import NewClassroomModal from "./modals/NewClassroomModal";

const StyledModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const AssignExamToClassroomModal = ({
  onSelect,
  isLoading,
  ...props
}: ModalProps & {
  onSelect?: (classroom: Classroom) => void;
  isLoading?: boolean;
}) => {
  const [context] = useAppContext();
  const newClassroomModal = useModal();
  const [classroom, setClassroom] = useState<Classroom | null>(null);

  const classroomsQuery = useQueryGetUserClassrooms(
    context.workspaceUser?.id,
    context.user?.id,
  );

  const classrooms = classroomsQuery.data
    ?.filter(exists)
    .map((c) => c.classroom)
    .filter(exists)
    .map((c) => ({
      label: c.name ?? "",
      value: c.id,
      classroom: c,
    }));

  return (
    <>
      <Modal
        title="Select Classroom"
        onAfterOpen={() => {
          setClassroom(classrooms?.[0]?.classroom ?? null);
        }}
        buttons={
          <>
            <Toolbar>
              <Button
                title="New Classroom"
                onClick={() => newClassroomModal.open()}
              >
                New Classroom
              </Button>
              <Button title="Cancel" onClick={props.onRequestClose}>
                Cancel
              </Button>
              <Button
                title="Assign to Classroom"
                color="primary"
                disabled={!classroom || isLoading}
                isLoading={isLoading}
                onClick={async () => {
                  if (!classroom) return;
                  onSelect?.(classroom);
                }}
              >
                Assign
              </Button>
            </Toolbar>
          </>
        }
        {...props}
      >
        <Modal.PaddedBody>
          <StyledModalForm>
            <SelectInput
              options={classrooms}
              value={classroom?.id}
              onChange={(v) => {
                setClassroom(
                  classrooms?.find((c) => c.value === v?.value)?.classroom ??
                    null,
                );
              }}
            />
          </StyledModalForm>
        </Modal.PaddedBody>
      </Modal>
      <NewClassroomModal
        {...newClassroomModal.modalProps}
        // todo: this should be a prop...
        // hideCourseInputs
        hideCourseInput
        hideSubjectInput
        hideGradeInput
        onCreate={() => {
          classroomsQuery.refetch();
        }}
      />
    </>
  );
};

export default AssignExamToClassroomModal;
